import { Component, DestroyRef, OnInit, Renderer2, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoggingService, SignalRHub } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { NavigationService, NavigationSettings } from '@fgb/portal-component-library/src/lib/shared/services';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'fgb-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.scss'],
})
export class MasterPageComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  screenType = ScreenType;
  navigationSettings: NavigationSettings;
  isScorecardDescription = false;

  constructor(
    private signalRHub: SignalRHub,
    private logService: LoggingService,
    // private notificationCenterService: NotificationCenterService,
    private navigationService: NavigationService,
    private router: Router,
    private renderer: Renderer2
  ) {}

  private updateScorecardClass(isScorecard: boolean) {
    if (isScorecard) {
      this.renderer.addClass(document.body, 'scorecard-description-page');
    } else {
      this.renderer.removeClass(document.body, 'scorecard-description-page');
    }
  }

  ngOnInit() {
    this.signalRHub.connectionEstablished$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((connection) => {
      this.logService.debug('SignalR connection', connection);
    });
    // this.notificationCenterService.fetchNotificationCenter(5).pipe(takeUntilDestroyed(this._destroyRef)).subscribe();

    // Subscribe to navigation changes
    this.navigationService.onNavigationChanged.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((navigationSettings) => {
      this.navigationSettings = navigationSettings;
    });

    this.isScorecardDescription = this.router.url.includes('scorecard-description');

    this.updateScorecardClass(this.isScorecardDescription);
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe((e) => {
        const url = (e as NavigationEnd).urlAfterRedirects;
        this.isScorecardDescription = url.includes('scorecard-description');
        this.updateScorecardClass(this.isScorecardDescription);
      });
  }
}
